import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-sim-tea",
  "use": "icon-soc-sim-tea-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-sim-tea\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<rect x=\"192\" y=\"224\" width=\"640\" height=\"576\" rx=\"48\" /><path d=\"M192 224h640v96H192z\" fill=\"#fff\" fill-opacity=\".25\" /><path d=\"M448 448l192 112-192 112V448z\" fill=\"#fff\" /><path d=\"M352 288h96v48H352zM352 352h160v32H352z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-sim-tea.svg
// module id = axAL
// module chunks = 488